import { render, staticRenderFns } from "./VerificationPendingBanner.vue?vue&type=template&id=0ac95928&scoped=true"
import script from "./VerificationPendingBanner.vue?vue&type=script&lang=js"
export * from "./VerificationPendingBanner.vue?vue&type=script&lang=js"
import style0 from "./VerificationPendingBanner.vue?vue&type=style&index=0&id=0ac95928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac95928",
  null
  
)

export default component.exports